import { FC } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { UserScrapType } from 'generated/graphql'
import ScreenScrapNewsListMobile from '@app.feature/accounts/scrap/mobile/screen/ScreenScrapNewsList.mobile'
import AnalysisScrapListMobile from '../component/AnalysisScrapList.mobile'
import CompanyScrapList from '../component/CompanyScrapList'
import ScrapListMobile from '../component/ScrapList.mobile'
import ScrapTabMobile from '../component/ScrapTab.mobile'

export const COMPANY_ANALYSIS = 'COMPANY_ANALYSIS'
export const COMPANY = 'COMPANY'

const ScreenScrapMobile: FC = () => {
  const router = useRouter()

  const renderScrapList = () => {
    switch (router.query.tab) {
      case COMPANY:
        return <CompanyScrapList />
      case UserScrapType.NEWS_ITEM:
        return <ScreenScrapNewsListMobile />
      case COMPANY_ANALYSIS:
        return <AnalysisScrapListMobile />
      default: // 공고, 합격자소서, 커뮤니티
        return <ScrapListMobile />
    }
  }

  return (
    <StyledWrapper>
      <div className="title-box">
        <h1 className="title">스크랩</h1>
      </div>
      <div className="tab-box">
        <ScrapTabMobile />
        {renderScrapList()}
      </div>
    </StyledWrapper>
  )
}

export default ScreenScrapMobile

const StyledWrapper = styled.div`
  .title-box {
    background-color: white;
    display: flex;
    align-items: center;
    padding: 13px 0px 13px 20px;
    border-bottom: 1px solid #ddd;
  }

  .title {
    font-weight: 700;
    color: #333333;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    letter-spacing: -0.6px;
  }

  .tab-box {
    position: relative;
  }
`
